module.exports = __webpack_public_path__ + "static/media/arrows.75dff91b.png";